/*
 * Styleguide route — renders a landing card with a link to the standalone
 * /styleguide.html page (a separate Vite entry owned by M0-2).
 *
 * Earlier revisions did `window.location.href = '/styleguide.html'` directly,
 * but that mixed full-page navigation with hash routing: browser-back from
 * /styleguide.html would either reload #/styleguide (re-triggering the
 * redirect) or drop the hash entirely, depending on the browser. A link in
 * a new tab avoids both problems and is honest about the fact that the
 * styleguide is a separate dev page, not a router-managed screen.
 *
 * Migrating the full styleguide content into a TS render function stays out
 * of scope until M5 (when the styleguide is removed before ship).
 */

export function renderStyleguide(mount: HTMLElement): void {
  const card = document.createElement('article');
  card.className = 'card card--elevated';

  const tag = document.createElement('span');
  tag.className = 'tag tag--eyebrow';
  tag.textContent = 'Dev tool';
  card.appendChild(tag);

  const heading = document.createElement('h1');
  heading.style.marginTop = 'var(--space-4)';
  heading.textContent = 'Design System Styleguide';
  card.appendChild(heading);

  const body = document.createElement('p');
  body.style.marginTop = 'var(--space-3)';
  body.style.color = 'var(--color-text-warm)';
  body.textContent =
    'The styleguide lives at a separate URL while the hash router is young. ' +
    'Opens in a new tab so your app navigation history stays clean.';
  card.appendChild(body);

  const link = document.createElement('a');
  // CF Pages strips `.html` and 308-redirects `/foo.html` → `/foo`; link
  // directly to the extensionless path to skip the round-trip. Vite dev
  // also serves `/styleguide` (without extension) when the multi-page
  // entry is registered, so this works in both environments.
  link.href = '/styleguide';
  link.target = '_blank';
  link.rel = 'noopener';
  link.className = 'btn btn--primary';
  link.style.marginTop = 'var(--space-5)';
  link.textContent = 'Open styleguide →';
  card.appendChild(link);

  mount.appendChild(card);
}
